import * as React from 'react';
import * as controller from '../controller'
import { withLocalize } from "react-localize-redux";

class Category extends React.Component<any, any> {

  handleCategoryChange: any
  updateCategory:any

  constructor(props: any) {
    super(props);
    this.state = {
      category: {
        id: null,
        title: null,
        updated: false
      },
      updating: false
    }
    this.updateCategory = controller.updateCategory.bind(this)
    this.handleCategoryChange = controller.handleCategoryChange.bind(this)
  }



  componentDidMount() {
    if(this.props.match.params.id && !isNaN(this.props.match.params.id)) {
      this.loadCategory(this.props.match.params.id)
    }

  }

  componentWillReceiveProps(nextProps: any) {
    if(nextProps.match.params.id
      && !isNaN(nextProps.match.params.id)
      && this.state.category.id != nextProps.match.params.id) {
      this.loadCategory(nextProps.match.params.id)
    } else {
      this.setState({
        category: {
          id: null,
          title: null
        }
      })
    }

  }



  loadCategory(id:any) {
    fetch('categories/get', {
      method: 'POST',
      body: JSON.stringify({id})
    }).then(results => {
      return results.json();
    }).then(data => {
        let category = data.category
        category.updated = true
        this.setState({category})
    }).catch(err => {
      alert(err.message);
    })
  }


  public render() {
    let category = this.state.category
    return (
      <div id="edit-account-root">
          <i onClick={() => {this.props.history.goBack()}} className="fas fa-times"></i>
          <form className="data">
            <input className="third" onChange={this.handleCategoryChange} defaultValue={category.title} name="title" placeholder={this.props.translate("name").toString()} />

            {(window.account.id == category.id || window.account.type == "admin") && <div><button className={"update "+((category.id && category.updated)? "updated" : "")} onClick={this.updateCategory} disabled={category.updated || this.state.updating}>
              {this.state.updating? this.props.translate("updating").toString() :
                category.id? category.updated? this.props.translate("updated").toString() :
                this.props.translate("update").toString() :
                this.props.translate("save").toString()}
            </button>
            </div>}
          </form>
        </div>
    )
  }
}

export default withLocalize(Category)



// WEBPACK FOOTER //
// ./src/pages/user/categories/Category.tsx